module.exports = __webpack_public_path__ + "static/media/activate.b02c06d0.png";